export default {
  state: {
    /* 게임 구동에 필요한 옵션 */
    auth: false,
    mode: null, // 게임 모드 (타임어택, 훈련)
    game: null, // 게임 이름
    count: 0, // 게임별 외울 문제의 갯수
    time: 0, // 기억 제한 시간
    units: 0, // 단위
    recall: 0, // 리콜 시간
    /* 랭킹 측정에 필요한 옵션 */
    answer: [], // 직접 등록한 답안
    score: 0, // 맞춘 정답의 갯수
    usedTime: 0, // 사용한 시간
    input: [], // 내가 입력한 정답
    bestScore: 0, // 최고 기록
    bestTime: 0, // 최고 시간
  },
  mutations: {
    // [fetchMe](state, me) {
    //   state.me = me;
    // },
    setAuth(state, auth) {
      state.auth = auth;
    },
    setMode(state, mode) {
      state.mode = mode;
    },
    setGame(state, game) {
      state.game = game;
    },
    setCount(state, count) {
      state.count = count;
    },
    setTime(state, time) {
      state.time = time;
    },
    setUnits(state, units) {
      state.units = units;
    },
    setRecall(state, recall) {
      state.recall = recall;
    },
    setAnswer(state, answer) {
      state.answer = answer;
    },
    setScore(state, score) {
      state.score = score;
    },
    setUsedTime(state, time) {
      state.usedTime = time;
    },
    setInput(state, input) {
      state.input = input;
    },
    setBestScore(state, score) {
      state.bestScore = score;
    },
    setBestTime(state, time) {
      state.bestTime = time;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js